module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-why-before"
  }, [_c('div', {
    staticClass: "custom-why-before__container"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "custom-why-before__slider-container",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.props), function(slide, i) {
    return _c('swiper-slide', {
      key: i,
      staticClass: "custom-why-before__slider",
      style: ({
        backgroundImage: 'url(' + slide.url + ')'
      })
    })
  }), 1), _c('div', {
    staticClass: "custom-why-before__next",
    on: {
      "click": _vm.slideNext
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-down"
    }
  })], 1), _c('div', {
    staticClass: "custom-why-before__prev",
    on: {
      "click": _vm.slidePrev
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-down"
    }
  })], 1), _c('div', {
    staticClass: "custom-why-before__pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1), _c('Icon', {
    staticClass: "custom-why-before__footer-divider",
    attrs: {
      "name": "patient-top-blue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f889bc7c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-why-before/custom-why-before.pug
// module id = 729
// module chunks = 1